import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import React, { useEffect, useState } from "react";
import { registerLocale } from "react-datepicker";
import { useTranslation } from "react-i18next";
import { Col, Label, Row } from "reactstrap";
import UploadFile from "components/Common/UploadFile";
import DropdownAsyncBannerPosition from "components/Common/DropdownAsyncBannerPosition";
import UploadImage from "components/Common/UploadImage";
import { ColorPicker } from "antd";

export interface Props {
  formik: any;
  listCheckedBannerPosition?: any;
  setListCheckedBannerPosition?: any
}

registerLocale("en", en);
registerLocale("ko", ko);

const BannerPremiumSection = ({ formik, listCheckedBannerPosition, setListCheckedBannerPosition }: Props) => {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <div
        className="d-flex flex-column mb-4 mt-4 pt-3 pb-1 px-3 position-relative"
        style={{
          border: "1px dashed var(--vz-primary)",
          borderRadius: "4px",
        }}
      >
        <span
          className="text-primary position-absolute fs-13 px-1"
          style={{
            backgroundColor: "var(--vz-secondary-bg)",
            top: "0px",
            transform: "translateY(-50%)",
          }}
        >
          {t("Premium Banner Applied")}
        </span>
        <Row className="mb-3 mt-1">
          <Col md={12} lg={12}>
            <div className="mb-3">
              <Label className="form-label">
                {t("Banner Position")}{" "}
              </Label>

              <DropdownAsyncBannerPosition
                name="bannerPositionIds"
                onChangeSelect={(e: any) => {
                  setListCheckedBannerPosition && setListCheckedBannerPosition(e);

                  if (e?.length > 0) {
                    const formatIds = e?.map(
                      (item: any) => item?.value
                    );
                    formik.setFieldValue(
                      "bannerPremium.bannerPositionIds",
                      formatIds
                    );
                  } else {
                    formik.setFieldValue("bannerPremium.bannerPositionIds", []);
                  }
                }}
                isMulti={true}
                placeholder={`${t("Select Banner Position")}...`}
                listCheckedOption={listCheckedBannerPosition}
                isAllOption={false}
                hideSelectedOptions={false}
              />

              {formik.touched?.bannerPremium?.bannerPositionIds &&
              formik.errors?.bannerPremium?.bannerPositionIds ? (
                <div className="text-danger mt-2">
                  {formik.errors?.bannerPremium?.bannerPositionIds}
                </div>
              ) : null}
            </div>
          </Col>
          <Col md={12} lg={12}>
            <Label className="form-label">
              {t("Banner Image")}{" "}
            </Label>
            <UploadImage
              data={formik.getFieldProps("bannerPremium.bannerImage")?.value}
              formik={formik}
              isMultiple={false}
              formikNameImage="bannerPremium.bannerImage"
              uploadProps={{
                name: "files",
                accept: "image/png",
                beforeUpload: () => false,
                headers: {
                  authorization: "authorization-text",
                },
              }}
            />

            {formik.touched?.bannerPremium?.bannerImage && formik.errors?.bannerPremium?.bannerImage ? (
              <div className="text-danger mt-2">
                {formik.errors?.bannerPremium?.bannerImage}
              </div>
            ) : null}
          </Col>
          <Col md={4} lg={4} className="mt-3">
            <label className="form-label w-100">
              {`${t("Background Color")}`}{" "}
            </label>
            <ColorPicker
              defaultValue="#1677ff"
              showText
              allowClear
              onChange={(value) => {
                let color = undefined;
                if (!value?.cleared) {
                  color =
                    typeof value == "string" ? value : value?.toHexString();
                }

                formik.setFieldValue(`bannerPremium.bgColor`, color);
              }}
              value={formik.values?.bannerPremium?.bgColor}
            />{" "}
            {formik.touched.bannerPremium?.bgColor &&
            formik.errors.bannerPremium?.bgColor ? (
              <div className="text-danger mt-2">
                {formik.errors.bannerPremium?.bgColor}
              </div>
            ) : null}
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
};

export default BannerPremiumSection;
